import React from 'react';
import PropTypes from 'prop-types';

import {translate} from 'views/module';

import CompactDropdown from './CompactDropdown';

import {convertToE164} from 'utils/miscellaneous/e164';

// Slugs must match the event types on the CareQuilt Cal.com team page
const CAL_TEAM_URL = 'https://cal.com/team/carequilt';
const CALL_TYPES = [
  {slug: 'kickoff-call', labelKey: 'client.ClientDetail.Status.Metrics.CallTypes.Kickoff'},
  {slug: 'care-planning', labelKey: 'client.ClientDetail.Status.Metrics.CallTypes.Intro'},
];

const BookCallDropdown = (props) => {
  const {label, primaryRelationship} = props;

  const bookCallLabel = translate('client.ClientDetail.Status.Metrics.BookCall');
  const menuLabel = translate('client.ClientDetail.Status.Metrics.CallType');

  const getCallTypeLink = (callType) => {
    const email = primaryRelationship?.email ?? '';
    const rawPhoneNumber = (primaryRelationship?.phoneNumber ?? '').trim();
    const phoneNumber = convertToE164(rawPhoneNumber, ['CA', 'US']).e164Format ?? rawPhoneNumber;
    const params = new URLSearchParams({
      name: (primaryRelationship?.name ?? '').trim(),
      email,
      utm_term: primaryRelationship?.relationshipRn ?? '',
      utm_source: email,
    });

    if (phoneNumber) {
      params.set('location', JSON.stringify({value: 'phone', optionValue: phoneNumber}));
      params.set('attendeePhoneNumber', phoneNumber);
    }

    return `${CAL_TEAM_URL}/${callType.slug}?${params.toString()}`;
  };

  return (
    <CompactDropdown
      getOptionHref={getCallTypeLink}
      getOptionKey={(callType) => callType.slug}
      getOptionLabel={(callType) => translate(callType.labelKey)}
      label={label}
      menuLabel={menuLabel}
      options={CALL_TYPES}
      value={bookCallLabel}
      valueColor='#DA7955'
      valueHref={CAL_TEAM_URL}
    />
  );
};

BookCallDropdown.propTypes = {
  label: PropTypes.string,
  primaryRelationship: PropTypes.object,
};

export default BookCallDropdown;
